export const BANNER_GET = 'bannerGet'
export const BANNERS_GET = 'bannersGet'
export const BANNER_DELETE = 'bannerDelete'
export const BANNER_CREATE = 'bannerCreate'
export const BANNER_UPDATE = 'bannerUpdate'
